export default __webpack_public_path__ + "static/media/button-hearts-fireworks-rocket-svgrepo-com.a806cfd4.svg";